// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1lScP","rippleContainer":"button-module--rippleContainer--3ay8k","ripple":"button-module--ripple--2gP7D"};